import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

function loader({ title, loading }) {
	return <>{loading ? <BeatLoader color='#656565' loading={loading} size={10} css='position : relative ; top : 3px' /> : title}</>;
}

export default loader;
